import { AssetImageFormat, AssetMode } from "../enums.ts";
import { getEnv, hasEnv } from "../helpers/env.ts";

export const defAssetQuality = 70;

export function getImgUrl(mode: AssetMode, id: number, filename = '', width: number = 0, height: number = 0, quality: number|string = null) {
	const prefix = (hasEnv('PUBLIC_ASSET_HOST') ? getEnv('PUBLIC_ASSET_HOST') : '');

	if (!hasEnv('PUBLIC_ASSET_HOST')) {
		console.info('missing PUBLIC_ASSET_HOST');
	}

	return prefix + getImgUrlRelative(mode, id, filename, width, height, quality);
}

export function getImgUrlRelative(mode: AssetMode, id: number, filename = '', width: number = 0, height: number = 0, quality: number|string = null) {
	if (quality === null || quality === "" || Number.isNaN(<number>quality)) {
		quality = 'def';
	}

	switch (mode) {
		case AssetMode.Full:
			return '/asset/' + id + "/" + width + '-' + height + '-' + quality + '/' + filename;
		case AssetMode.Thumb:
			return '/asset/crop/' + id + "/" + width + '-' + height + '-' + quality + '/' + filename;
		case AssetMode.Media:
			return '/asset/media/' + id + "/" + filename;
	}
}

export function getFileNameWithoutExtension(filename: string = '') {
	return filename.substring(0, filename.lastIndexOf(('.'))) || filename;
}

export function getFileExtensionFromFilename(filename: string = '') {
	return filename.substring(filename.lastIndexOf('.') + 1, filename.length);
}

export function getAssetImageFormatFromFileExtension(extension: string = ''): AssetImageFormat {
	switch (extension.toLowerCase()) {
		case 'png': return AssetImageFormat.Png;
		case 'webp': return AssetImageFormat.Webp;
		case 'jpg':
		case 'jpeg':
			return AssetImageFormat.Jpg;
	}

	return null;
}

export function getAssetFileIconClass(fileMimeExtension: string) {
	switch (fileMimeExtension) {
		case 'pdf':
			return 'icon-file-pdf';
		case 'docx':
		case 'doc':
			return 'icon-file-word';
		case 'xlsx':
		case 'xls':
			return 'icon-file-excel';
		case 'pptx':
		case 'ppt':
			return 'icon-file-powerpoint';
		case 'zip':
		case '7z':
		case 'rar':
			return 'icon-file-zipper';
	}

	return 'icon-file';
}


export type AssetUrl = {
	id?: number;
	filename: string;
	format?: AssetImageFormat;
	width: number;
	height: number;
	quality: number|string;
}


export function parseAssetUrl(url = ''):AssetUrl {
	let toReturn: AssetUrl = {
		id: null,
		filename: '',
		format: null,
		width: 0,
		height: 0,
		quality: <number|string>'def'
	};

	const parts = url.split('/');
	toReturn.filename = parts.pop();
	toReturn.format = getAssetImageFormatFromFileExtension(getFileExtensionFromFilename(toReturn.filename));
	toReturn.id = Number.parseInt(parts.find((element: any) => element.match(/^\d+$/) !== null));

	const sizesPart = parts.find((element) => element.match(/^\d+-\d+-\w{1,3}$/) !== null);
	if (sizesPart) {
		const sizesPartArray = sizesPart.split('-');
		if (Array.isArray(sizesPartArray) && sizesPartArray.length === 3) {
			toReturn.width = Number.parseInt(sizesPartArray[0]);
			toReturn.height = Number.parseInt(sizesPartArray[1]);
			toReturn.quality = Number.parseInt(sizesPartArray[2]);
		}
	}

	return toReturn;
}
